<template>
    <div class="article-preview">
        <div class="content">
            <!-- eslint-disable vue/no-v-html-->
            <h3
                class="title"
                v-html="parseTitle(data.title)"
            ></h3>

            <p class="subtitle">{{ data.subtitle }}</p>

            <ThLink
                v-bind="bind"
                class="link"
            >
                {{ data.link.text }}
            </ThLink>
        </div>

        <div class="image">
            <CmsImage
                :data="data.image"
                :is-eager="hasEagerImage"
                fit="cover"
                :sizes="sizes"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import type { ArticlePreviewFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms'

import CmsImage from '@/components/cms/CmsImage.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import type { ImageSizes } from '@/components/getImageProps.ts'

const props = defineProps<{
    data: ArticlePreviewFragment
    hasEagerImage?: boolean
    sizes?: ImageSizes
}>()

const bind = useCmsLink(toRef(() => props.data.link))

const parseTitle = (title: string) =>
    title.replace('&', '<span class="th-ampersand">&</span>')
</script>

<style lang="scss" scoped>
.article-preview {
    width: 100%;
    aspect-ratio: 1/1;
    position: relative;

    .image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .content {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
        background: linear-gradient(
            to bottom,
            rgba($black, 0) 30%,
            rgba($black, 0.7) 100%
        );
        color: $white;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-end;
        padding: 20px;
        text-align: center;

        .title {
            font-size: 1.8rem;
            line-height: 1em;
            margin: 0 0 20px;
            font-family: $parcel-font-stack;
            letter-spacing: 0.01em;
            position: relative;
            z-index: 2;

            .th-amperstand {
                @include th-ampersand;
            }
        }

        .subtitle {
            font-size: 0.9rem;
        }

        :deep(.link) {
            display: block;
            font-family: $effra-font-stack;
            letter-spacing: 0.05em;
            font-size: 0.65rem;
            font-weight: 400;
            text-transform: uppercase;
            text-decoration: underline;
            margin: 20px 0 0;
        }
    }
}
</style>
